import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as $ from 'jquery';

/*
  Generated class for the ConsultationDisplayProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConsultationDisplayProvider
{

   public dispCats = [ '服用方法', '複方', '單方', '水蜜丸劑', '內服中藥', '外用產品', '複針基本穴位', '單針穴位' ];
   public diagnoses: any = [];
   public symptoms: any = [];
   public dispSingleCat: any = [];
   public dispSingle = [];
   public dispGrp = [];
   public dispInternal = [];
   public dispExternal = [];
   public dispPills = [];
   public acuSingle = [];
   public acuGrp = [];
   public usages = [];


   constructor( public http: HttpClient ) {}

   initData = () => {

      return new Promise( resolve => {

         this.initDiagnose().then( res => {

            this.initSymptoms().then( res => {

               this.initDispSingleCat().then( res => {

                  this.initDispSingle().then( res => {

                     this.initDispGrp().then( res => {

                        this.initDispInternal().then( res => {

                           this.initDispExternal().then( res => {

                              this.initDispPills().then( res => {

                                 this.initAcuSingle().then( res => {

                                    this.initAcuGrp().then( res => {

                                       this.initUsage().then( res => {

                                          resolve();
                                       });
                                    });
                                 });
                              });
                           });
                        });
                     });
                  });
               });
            });
         });
      });
   }

   /** ----- Symptoms ----- **/

   initDiagnose = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/diagnose.json' ).subscribe( res => {

            // save result
            this.diagnoses = res;
            resolve();
         });
      });
   }


   /** ----- Symptoms ----- **/

   initSymptoms = () => {

      return new Promise( resolve => {

         // download JSON file
         this.http.get( './assets/json/symptoms.json' ).subscribe( res => {

            // temp list
            let list: any = [];
            list = res;
            let result: any = [];

            // loop through result
            for ( let i = 0; i < list.length; i++ )
            {
               // try to get if grp already exists
               let idx = this.findSymptomGrpIdx( list[ i ][ 'name_zh' ], result );

               // if exists
               if ( idx > -1 )
               {
                  // push to same grp
                  result[ idx ][ 'data' ].push( list[ i ] );
               }
               // else does not exist
               else
               {
                  // create grp and add to the list
                  let param = {
                     'name_zh' : list[ i ][ 'name_zh' ],
                     'data'    : [ list[ i ] ]
                  };
                  result.push( param );
               }
            }

            // save result
            this.symptoms = result;
            resolve();
         });
      });
   }


   private findSymptomGrpIdx( inStr, inList )
   {

      // loop through the list
      for ( let i = 0; i < inList.length; i++ )
      {
         // ONLY return the index if grp matches
         if ( inList[ i ][ 'name_zh' ] == inStr )
         {
            return i;
         }
      }

      // else default return -1
      return -1;

   }


   public findSymptom( inId )
   {

      // loop groups
      for ( let i = 0; i < this.symptoms.length; i++ )
      {
         // find item in group
         let result = $.grep( this.symptoms[ i ][ 'data' ], function( element, index ) {
            return element[ 'id' ] == inId;
         });

         // ensure ONLY one result, then return
         if ( result.length == 1 ) return result[ 0 ];
      }

      // default return null
      return null;

   }


   /** ----- Dispensay - Single Category ----- **/

   initDispSingleCat = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/disp-single-cat.json' ).subscribe( res => {

            // save result
            this.dispSingleCat = res;
            resolve();
         });
      });
   }


   private findDispSingleCatById( inId )
   {

      // loop through dispSingleCat
      for ( let i = 0; i < this.dispSingleCat.length; i++ )
      {
         // ONLY return if requested category found
         if ( this.dispSingleCat[ i ][ 'id' ] == inId )
         {
            return this.dispSingleCat[ i ];
         }
      }

      // return null if nth found
      return null;

   }


   /** ----- Dispensay - Single ----- **/

   initDispSingle = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/disp-single.json' ).subscribe( res => {

            // loop through result
            let result: any = [];
            result = res;
            for ( let i = 0; i < result.length; i++ )
            {
               // add 'type' and reset 'category_id'
               result[ i ][ 'type' ] = 'disp-single';
               result[ i ][ 'category_id' ] = this.findDispSingleCatById( result[ i ][ 'category_id' ] );
            }

            // save result
            this.dispSingle = result;
            resolve();
         });
      });
   }


   private findDispSingleItemById( inId )
   {

      // find item in group
      let result = $.grep( this.dispSingle, function( element, index ) {
         return element[ 'id' ] == inId;
      });

      // else default return -1
      return ( result.length > 0 ) ? result[ 0 ] : null;

   }


   /** ----- Dispensary - Group ----- **/

   initDispGrp = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/disp-grp.json' ).subscribe( res => {

            // loop every item in JSON file
            let list: any = [];
            list = res;
            let result: any = [];
            for ( let i = 0; i < list.length; i++ )
            {
               // try to get if grp already exists
               let idx = this.findDispItemGrpIdx( list[ i ][ 'grp_id' ], result );

               // if exists
               if ( idx > -1 )
               {
                  // push to same grp
                  let obj = this.findDispSingleItemById( list[ i ][ 'item_id' ] );
                  if ( obj != null )
                  {
                     obj[ 'ratio' ] = list[ i ][ 'ratio' ];
                  }
                  result[ idx ][ 'data' ].push( obj );
               }
               // else does not exist
               else
               {
                  // create grp and add to the list
                  let obj = this.findDispSingleItemById( list[ i ][ 'item_id' ] );
                  if ( obj != null )
                  {
                     obj[ 'ratio' ] = list[ i ][ 'ratio' ];
                  }
                  let param = {
                     'grp_id'    : list[ i ][ 'grp_id' ],
                     'name_zh'   : list[ i ][ 'name_zh' ],
                     'name_en'   : list[ i ][ 'name_en' ],
                     'usage_ref' : list[ i ][ 'usage_ref' ],
                     "default"   : list[ i ][ 'default' ],
                     'data'      : [ obj ],
                     'type'      : 'disp-grouped'
                  };
                  result.push( param );
               }
            }

            // save result
            this.dispGrp = result;
            resolve();
         });
      });
   }


   private findDispItemGrpIdx( inId, inList )
   {

      // loop through the list
      for ( let i = 0; i < inList.length; i++ )
      {
         // ONLY return the index if grp matches
         if ( inList[ i ][ 'grp_id' ] == inId )
         {
            return i;
         }
      }

      // else default return -1
      return -1;

   }


   /** ----- Dipensary - Internal ----- **/

   initDispInternal = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/disp-internal.json' ).subscribe( res => {

            // loop through result
            let result: any = [];
            result = res;
            for ( let i = 0; i < result.length; i++ )
            {
               // add 'type'
               result[ i ][ 'type' ] = 'disp-internal';
            }

            // save result
            this.dispInternal = result;
            resolve();
         });
      });
   }


   /** ----- Dispensary - External ----- **/

   initDispExternal = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/disp-external.json' ).subscribe( res => {

            // loop through result
            let result: any = [];
            result = res;
            for ( let i = 0; i < result.length; i++ )
            {
               // add 'type'
               result[ i ][ 'type' ] = 'disp-external';
            }

            // save result
            this.dispExternal = result;
            resolve();
         });
      });
   }


   /** ----- Dispensary - Pills ----- **/

   initDispPills = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/disp-pills.json' ).subscribe( res => {

            // loop every item in JSON file
            let list: any = [];
            list = res;
            let result: any = [];
            for ( let i = 0; i < list.length; i++ )
            {
               // try to get if grp already exists
               let idx = this.findPillsItemGrpIdx( list[ i ][ 'grp_id' ], result );

               // if exists
               if ( idx > -1 )
               {
                  // push to same grp
                  result[ idx ][ 'data' ].push( list[ i ] );
               }
               // else does not exist
               else
               {
                  // create grp and add to the list
                  let param = {
                     'default'   : list[ i ][ 'default' ],
                     'grp_id'    : list[ i ][ 'grp_id' ],
                     'name_zh'   : list[ i ][ 'name_zh' ],
                     'name_en'   : list[ i ][ 'name_en' ],
                     'data'      : [ list[ i ] ],
                     'type'      : 'disp-pills'
                  };
                  result.push( param );
               }
            }

            // save result
            this.dispPills = result;
            resolve();
         });
      });
   }


   private findPillsItemGrpIdx( inId, inList )
   {

      // loop through the list
      for ( let i = 0; i < inList.length; i++ )
      {
         // ONLY return the index if grp matches
         if ( inList[ i ][ 'grp_id' ] == inId )
         {
            return i;
         }
      }

      // else default return -1
      return -1;

   }


   /** ----- Acupuncture - Single ----- **/

   initAcuSingle = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/acu-single.json' ).subscribe( res => {

            // loop through result
            let result: any = [];
            result = res;
            for ( let i = 0; i < result.length; i++ )
            {
               // add 'type'
               result[ i ][ 'type' ] = 'acu-single';
            }

            // save result
            this.acuSingle = result;
            resolve();
         });
      });
   }


   /** ----- Acupuncture - Grouped ----- **/

   initAcuGrp = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/acu-grp.json' ).subscribe( res => {

            // loop every item in JSON file
            let list: any = [];
            list = res;
            let result: any = [];
            for ( let i = 0; i < list.length; i++ )
            {
               // try to get if grp already exists
               let idx = this.findAcuItemGrpIdx( list[ i ][ 'grp_id' ], result );

               // if exists
               if ( idx > -1 )
               {
                  // push to same grp
                  result[ idx ][ 'data' ].push( list[ i ] );
               }
               // else does not exist
               else
               {
                  // create grp and add to the list
                  let param = {
                     'grp_id'    : list[ i ][ 'grp_id' ],
                     'name_zh'   : list[ i ][ 'name_zh' ],
                     'name_en'   : list[ i ][ 'name_en' ],
                     'data'      : [ list[ i ] ],
                     'type'      : 'acu-grouped'
                  };
                  result.push( param );
               }
            }

            // save result
            this.acuGrp = result;
            resolve();
         });
      });
   }


   private findAcuItemGrpIdx( inId, inList )
   {

      // loop through the list
      for ( let i = 0; i < inList.length; i++ )
      {
         // ONLY return the index if grp matches
         if ( inList[ i ][ 'grp_id' ] == inId )
         {
            return i;
         }
      }

      // else default return -1
      return -1;

   }


   /** ----- Usage ----- **/

   initUsage = () => {

      return new Promise( resolve => {

         this.http.get( './assets/json/usage.json' ).subscribe( res => {

            let result: any = [];
            result = res;
            this.usages = result;
            resolve();
         });
      });
   }

}



// WEBPACK FOOTER //
// ./src/providers/consultation-display/consultation-display.ts